import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/FontAwesome/solid/bullseye.svg";

export function BullseyeClassicSolidIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
